var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('apexchart',{ref:"apexChart",attrs:{"width":"100%","height":"100%","options":_vm.computedChartOptions,"series":_vm.series}})}
var staticRenderFns = []

export { render, staticRenderFns }